<template>
  <div>
    <div class="relative w-80 dropdown-container">
      <!-- Search Input -->
      <input
        type="text"
        v-model="searchQuery"
        @input="fetchSuggestions"
        @focus="fetchSuggest"
        placeholder="Search..."
        class="w-full border rounded-full px-4 py-2"
      />
      <!-- Suggestions Dropdown -->
      <div
        v-if="showSuggestions"
        class="absolute top-full left-0 w-full bg-white border rounded-lg shadow-md mt-1 z-50 p-2"
      >
        <div>
          <ul v-if="suggestions.homeworks && suggestions.homeworks.length > 0">
            <li class="text-sm font-bold">Homeworks</li>
            <li
              v-for="(item, index) in suggestions.homeworks.slice(0, 2)"
              :key="index"
              @click="
                this.$router.push(
                  `/course/dashboard/${item.course_id}/${item.dept_id}/home-works`
                )
              "
              class="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs"
            >
              <p class="line-clamp-1">
                {{ item.title }}
              </p>
            </li>
          </ul>
        </div>
        <div>
          <ul
            v-if="suggestions.assignments && suggestions.assignments.length > 0"
          >
            <li class="text-sm font-bold">Assignments</li>
            <li
              v-for="(item, index) in suggestions.assignments.slice(0, 2)"
              :key="index"
              @click="
                this.$router.push(
                  `/course/dashboard/${item.course_id.id}/${item.dept_id}/assignments`
                )
              "
              class="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div>
          <ul v-if="suggestions.projects && suggestions.projects.length > 0">
            <li class="text-sm font-bold">Projects</li>

            <li
              v-for="(item, index) in suggestions.projects.slice(0, 2)"
              :key="index"
              @click="
                this.$router.push(
                  `/course/dashboard/${item.team_course_id}/${item.dept_id}/blogs`
                )
              "
              class="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div>
          <ul v-if="suggestions.courses && suggestions.courses.length > 0">
            <li class="text-sm font-bold">Courses</li>

            <li
              v-for="(item, index) in suggestions.courses.slice(0, 2)"
              :key="index"
              @click="
                this.$router.push(
                  `/course/dashboard/${item.id}/${item.dept_id}/students`
                )
              "
              class="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div>
          <ul
            v-if="
              suggestions.course_quizzes &&
              suggestions.course_quizzes.length > 0
            "
          >
            <li class="text-sm font-bold">Assessment</li>

            <li
              v-for="(item, index) in suggestions.course_quizzes.slice(0, 2)"
              :key="index"
              @click="
                this.$router.push(
                  `/course/dashboard/${item.course}/${item.dept_id}/quizs`
                )
              "
              class="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      searchQuery: "",
      suggestions: {
        homeworks: [],
        assignments: [],
        projects: [],
        courses: [],
        course_quizzes: [],
      },
      showSuggestions: false,
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {},
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.showSuggestions = false;
      }
    },
    async fetchSuggest() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/academic-data/list/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.suggestions = response.data.data || {};
            this.showSuggestions = true;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async fetchSuggestions() {
      if (!this.searchQuery) {
        this.suggestions = [];
        this.showSuggestions = false;
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/academic-data/list/?search=${this.searchQuery}&Key=${this.userInfo.token_key}`
        );
        if (res.data.status == 200 && res.data.count > 0) {
          this.suggestions = res.data.data || {};
          this.showSuggestions = true;
        }
        if (res.data.count == 0) {
          this.suggestions = res.data.data || {};
          this.showSuggestions = false;
        }
      } catch (err) {
        console.error("Error fetching suggestions:", err);
      }
    },
  },
};
</script>

<style></style>
